// extracted by mini-css-extract-plugin
module.exports = {"container":"RootCheckable_container__3NI8K","icon":"RootCheckable_icon__2F4Xh","txt":"RootCheckable_txt__31rOp","stateChecked":"RootCheckable_stateChecked__2PBI6"};